import React, { useState } from "react";
import classes from "../information/Header.module.css";
import HeaderCard from "../UI/HeaderCard";
import CountUp from "react-countup";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { forEach } from "lodash";

const transaction = ['closed won',"deal won"]

export const UniversalDateFormat = (date) => {
  // Transaction Count variables
  //console.log("date from header", date);

  if (date === undefined) return "";

  var components = date.split("/");
  //console.log(components)
  var newDate = components[1] + "-" + components[0] + "-" + components[2];
  //console.log(newDate,"hhhhhhhh ")

  const monthNumber = new Date(newDate).getMonth();
  let monthName;
  switch (monthNumber) {
    case 0:
      monthName = "Jan";
      break;
    case 1:
      monthName = "Feb";
      break;
    case 2:
      monthName = "Mar";
      break;
    case 3:
      monthName = "Apr";
      break;
    case 4:
      monthName = "May";
      break;
    case 5:
      monthName = "Jun";
      break;
    case 6:
      monthName = "Jul";
      break;
    case 7:
      monthName = "Aug";
      break;
    case 8:
      monthName = "Sep";
      break;
    case 9:
      monthName = "Oct";
      break;
    case 10:
      monthName = "Nov";
      break;
    case 11:
      monthName = "Dec";
      break;
    default:
      monthName = "None";
      break;
  }    

  return `${new Date(newDate).getDate()}/${monthName}/${new Date(
    newDate
  ).getFullYear()}`;
};

const Header = ({ data }) => {

  console.log("Date List from header",data);
  let ActivityData = [];
  if (data.length !== 0) {
    ActivityData = [...data];
  }

  //console.log("Activity Date", ActivityData);

  const upComming = [];
  const pastData =[]
  const upComingActivity = ActivityData.map((e) => {
    const currentDate = new Date();
    const itemDate = new Date(e.date);

    if (itemDate > currentDate) {
      upComming.push(e);
    }else{
      pastData.push(e)
    }
  });

  //console.log("upcoming", upComming);

  const pastActivity = ActivityData.filter((obj) => {
    return !upComming.some((el) => {
      return obj.date === el.date;
    });
  });

  //console.log("past Activity", pastActivity);

  let lastActivity = pastActivity.slice(0,1);
  //console.log("Last Activity",lastActivity);

  let formattedlastActfirst, formattedlastActLast, firstLastActDate, lastLastActDate;

  const [engagementVisible, setEngagementVisible] = useState(false);
  const [interactionVisible, setInteractionVisible] = useState(false);
  const [transactionVisible, setTransactionVisible] = useState(false);
  const [lastVisible, setLastVisible] = useState(false);
  let firstDate, lastDate, formattedfirst, formattedLast, totalDays;

   // const [leadscores,setleadScore]= useState(0)
   if (lastActivity.length !== 0) {
    //console.log("test 1");
    const first = lastActivity[lastActivity.length - 1].date;
    const last = lastActivity[0].date;

    console.log("first", first)

    formattedlastActfirst = new Date(first).toLocaleDateString("en-IN");

    console.log("first", formattedlastActfirst)

    formattedlastActLast = new Date(last).toLocaleDateString("en-IN");

    // function to calculate date in human redable format
    function dateCalculation(formattedDate) {
      const targetDate = new Date(formattedDate);
      // current date
      const currentDate = new Date();

      const timeDifference = currentDate - targetDate;
      let numberOfDays = timeDifference / (1000 * 60 * 60 * 24);
      // numberOfDays=5
      const isYear = Math.floor(numberOfDays / 365);
      // return Math.floor(numberOfDays / 365) + "years ago"
      // Calculate the differences in years, months, and days
      if (isYear === 0) {
        let date = "";
        switch (true) {
          case numberOfDays < 30:
            // date= Math.floor(numberOfDays) + " day's ago";
            date =
              Math.floor(numberOfDays) === 1
                ? Math.floor(numberOfDays) + " day ago"
                : +Math.floor(numberOfDays) + " days ago";
            break;

          default:
            date =
              Math.floor(numberOfDays / 30) === 1
                ? Math.floor(numberOfDays / 30) + " month ago"
                : +Math.floor(numberOfDays / 30) + " months ago";
            break;
        }
        return date;
      } else {
        return (Math.floor(numberOfDays) / 365).toFixed(1) + " years ago";
      }
    }

    firstLastActDate = dateCalculation(first);
    lastLastActDate = dateCalculation(last);
    
    const timeDifference = new Date() - new Date(last);
    totalDays = timeDifference / (1000 * 60 * 60 * 24);
  }

  // const [leadscores,setleadScore]= useState(0)
  if (data.length !== 0) {

    //console.log("test 2");

    const first = data[data.length - 1].date;
    const last = data[0].date;

    //console.log("first last", first, last)

    formattedfirst = new Date(first).toLocaleDateString("en-IN");

    formattedLast = new Date(last).toLocaleDateString("en-IN");

    // function to calculate date in human redable format
    function dateCalculation(formattedDate) {
      const targetDate = new Date(formattedDate);
      // current date
      const currentDate = new Date();

      const timeDifference = currentDate - targetDate;
      let numberOfDays = timeDifference / (1000 * 60 * 60 * 24);
      // numberOfDays=5
      const isYear = Math.floor(numberOfDays / 365);
      // return Math.floor(numberOfDays / 365) + "years ago"
      // Calculate the differences in years, months, and days
      if (isYear === 0) {
        let date = "";
        switch (true) {
          case numberOfDays < 30:
            // date= Math.floor(numberOfDays) + " day's ago";
            date =
              Math.floor(numberOfDays) === 1
                ? Math.floor(numberOfDays) + " day ago"
                : +Math.floor(numberOfDays) + " days ago";
            break;

          default:
            date =
              Math.floor(numberOfDays / 30) === 1
                ? Math.floor(numberOfDays / 30) + " month ago"
                : +Math.floor(numberOfDays / 30) + " months ago";
            break;
        }
        return date;
      } else {
        return (Math.floor(numberOfDays) / 365).toFixed(1) + " years ago";
      }
    }

    firstDate = dateCalculation(first);
    lastDate = dateCalculation(last);

    //console.log("first date formatted last date", firstDate, lastDate);

    const timeDifference = new Date() - new Date(last);
    totalDays = timeDifference / (1000 * 60 * 60 * 24);
  }

  let leadScore = 0;
  function LeadScoreCalculation() {
    if (pastData.length !== 0) {
      for (var i = 0; i < pastData.length; i++) {
        const today = new Date();
        const leadLast30 = new Date(); //data[i].
        leadLast30.setDate(today.getDate() - 30);

        const leadLast60 = new Date(); //data[i].
        leadLast60.setDate(today.getDate() - 60);

        const checkDate = new Date(pastData[i].date); //data[i].

        if (leadLast30 < checkDate) {
          leadScore = leadScore + 25;
        } else if (leadLast60 < checkDate) {
          leadScore = leadScore + 15;
        } else {
          leadScore = leadScore + (pastData.length - 1 - i + 1) * 10;
          // setleadScore(leadScore)
          break;
        }
      }
      //console.log("leadscore",leadScore);
    } else {
      return (leadScore = 0);
    }
  }

  const showInfoCard = () => {
    setEngagementVisible(true);
  };

  const hideInfoCard = () => {
    setEngagementVisible(false);
  };

  LeadScoreCalculation();
  let time = new Date(formattedLast).getTime() - new Date().getTime();
  const remainingDays = Math.ceil(time / (1000 * 60 * 60 * 24));

  // FUTURE LEAD SCORE

  let futureLeadScore = 0;

  function futureLeadScoreCalculation() {
    futureLeadScore=0
    if (upComming.length !== 0) {
      const today = new Date();
      for (var i = 0; i < upComming.length; i++) {
        const checkDate = new Date(data[i].date);
        if (checkDate > today) {
          // Check if lead date is in the future
          const leadDifference = Math.floor(
            (checkDate - today) / (1000 * 60 * 60 * 24)
          ); // Calculate difference in days
          if (leadDifference <= 30) {
            futureLeadScore += 25;
          } else if (leadDifference <= 60) {
            futureLeadScore += 15;
          } else {
            futureLeadScore += (upComming.length - 1 - i + 1) * 10;
            break;
          }
        }
        //console.log("future leadscore",futureLeadScore);
      }
    } else {
      futureLeadScore = 0;
    }
  }
  futureLeadScoreCalculation();
  
  return (
    <div>
      <div className={classes.headerMain}>
        {futureLeadScore ? (
          <>
            <HeaderCard>
              <div className={classes.headerContent}>
                <p>
                  <span style={{fontSize:"14px"}}>Future Engagement Score</span>{" "}
                  <span
                    className={classes.infoButton}
                    onMouseOver={() => setEngagementVisible(true)}
                    onMouseOut={() => setEngagementVisible(false)}
                  >
                    <QuestionMarkIcon
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#F3F8FF",
                        borderRadius: "50%",
                        padding: "2px",
                      }}
                    />
                    {engagementVisible && (
                      <div className={classes.infoCard}>
                        <h5>Future Engagement Score</h5>
                        <p>
                          Engagement Score reflects how the interactions are
                          quantified based on when the interactions happened and
                          how frequently they happened.
                        </p>
                      </div>
                    )}
                  </span>
                </p>

                <h2>
                  <CountUp delay={1} duration={3} start={0} end={futureLeadScore} />
                </h2>
              </div>
            </HeaderCard>
          </>
        ):<></>}
        <HeaderCard>
          <div className={classes.headerContent}>
            <p>
              <span>Engagement Score</span>{" "}
              <span
                className={classes.infoButton}
                onMouseOver={() => setEngagementVisible(true)}
                onMouseOut={() => setEngagementVisible(false)}
              >
                <QuestionMarkIcon
                  style={{
                    fontSize: "18px",
                    backgroundColor: "#F3F8FF",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                />
                {engagementVisible && (
                  <div className={classes.infoCard}>
                    <h5>Engagement Score</h5>
                    <p>
                      Engagement Score reflects how the interactions are
                      quantified based on when the interactions happened and how
                      frequently they happened.
                    </p>
                  </div>
                )}
              </span>
            </p>

            <h2>
              <CountUp delay={1} duration={3} start={0} end={leadScore} />
            </h2>
          </div>
        </HeaderCard>
        <HeaderCard>
          <div className={classes.headerContent}>
            <p>
              <span>Transactions</span>{" "}
              <span
                className={classes.infoButton}
                onMouseOver={() => setTransactionVisible(true)}
                onMouseOut={() => setTransactionVisible(false)}
              >
                <QuestionMarkIcon
                  style={{
                    fontSize: "18px",
                    backgroundColor: "#F3F8FF",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                />
                {transactionVisible && (
                  <div className={classes.infoCard}>
                    <h5>Transactions</h5>
                    <p>
                      This is the count of how many times you had a 'transaction
                      closure'. e.g. Sales Opportunity closure is a transaction.
                    </p>
                  </div>
                )}
              </span>
            </p>
            <h2>
              <CountUp
                delay={1}
                duration={3}
                start={0}
                end={data.filter((e) => transaction.includes(e.status.toLowerCase())).length}
              />
            </h2>
          </div>
        </HeaderCard>
        <HeaderCard>
          <div className={classes.headerContent}>
            <p>
              <span>Interactions </span>{" "}
              <span
                className={classes.infoButton}
                onMouseOver={() => setInteractionVisible(true)}
                onMouseOut={() => setInteractionVisible(false)}
              >
                <QuestionMarkIcon
                  style={{
                    fontSize: "18px",
                    backgroundColor: "#F3F8FF",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                />
                {interactionVisible && (
                  <div className={classes.infoCard}>
                    <h5>Interactions Date</h5>
                    <p>
                      This is the count of data points collected to calculate
                      Engagement Score
                    </p>
                  </div>
                )}
              </span>
            </p>
            <h2>
              <CountUp delay={1} start={0} duration={3} end={data.length} />
            </h2>
          </div>
        </HeaderCard>
      </div>

      {/* Second row of cards */}

      <div className={classes.headerMain}>
        <HeaderCard>
          <div
            className={classes.headerContent}
            style={{ paddingRight: "1.5em" }}
          >
            <p style={{ height: "40%" }}>
              <span> First Contact</span>
            </p>
            <h5
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                alignContent: "space-between",
              }}
            >
              <span
                style={{
                  // textAlign:"center"
                  height: "40%",
                }}
              >
                {firstDate}{" "}
              </span>
              <span
                style={{
                  height: "20%",
                  alignContent: "flex-end",
                  alignItems: "space-between",
                  marginTop: "5px",
                  marginBottom: "0",
                  fontSize: "0.8rem",
                  textAlign: "left",
                }}
              >
                {UniversalDateFormat(formattedfirst)}
              </span>
            </h5>
          </div>
        </HeaderCard>
        {lastActivity.length !==0 && (
        <HeaderCard>
          <div
            className={classes.headerContent}
            style={{ paddingRight: "1.5em" }}
          >
            <p>
              <span>Last Contact</span>
              <span
                className={classes.infoButton}
                onMouseOver={() => setLastVisible(true)}
                onMouseOut={() => setLastVisible(false)}
              >
                <QuestionMarkIcon
                  style={{
                    fontSize: "18px",
                    backgroundColor: "#F3F8FF",
                    borderRadius: "50%",
                    padding: "2px",
                  }}
                />
                {lastVisible && (
                  <div className={classes.infoCard}>
                    <h5>Last Contacted Date</h5>
                    <p>
                      This is the most recent interaction date. If this is shown
                      is red color then it is time for you to take action to
                      engage the customer
                    </p>
                  </div>
                )}
              </span>
            </p>
            <h5
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                alignContent: "space-between",
                color: Math.abs(totalDays) > 30 ? "#D80032" : "black",
              }}
            >
              <span style={{ display: "inline" }}> {firstLastActDate}</span>

              {formattedLast === undefined && (
                <span
                  style={{
                    alignItems: "flex-end",
                    marginTop: "5px",
                    fontSize: "0.8rem",
                    textAlign: "left",
                  }}
                >
                 {UniversalDateFormat(formattedlastActfirst)}
                </span>
              )}
            </h5>
          </div>
        </HeaderCard>
        )}
      </div>
    </div>
  );
};

export default Header;
